/**
 * Last Mile monitoring component
 * Allows configuration for domains in each site\account to which the socket pings every x configured seconds
 */

mainApp.component('lastMileDestinations', {
    templateUrl: '/public/components/last-mile-destinations.component.html',
    bindings: {
        lastMileRule: '=',
        defaultDestinations: '=',
        isSiteConfiguration: '=',
        ruleChanged: '&',
        modelId: '=',
        updateItemsToDelete: '&'
    },
    controller: lastMileDestinationsController
});

function lastMileDestinationsController($scope, GeneralUtilsService) {

    var ctrl = this;

    ctrl.$onInit = function(){
        //update excluded interfaces in selected items of interfaces table in popup
        ctrl.interfacesTableConfig.selectedItems = ctrl.lastMileRule.excludedInterfaces;
    }


    ctrl.selectInterfacesToExclude = function() {
         ctrl.datamodified = new Date().getTime();
         $scope.$root.openPopup("excludedInterfacesDlg_" + ctrl.modelId);
    }

    ctrl.interfacesTableConfig = {
             dataURL : function(){
                    return "/getSocketWanInterfaces?siteId=" + ctrl.modelId;
             },
             method: 'GET',
             type : "SocketInterface",
             noSearch: true,
             selectedItems: [],
             actions:[],
             fields : [
             {"label":"Interface Name","path":"","template":"<span>{{item.name}}</span>", noSort: true},
             ],
             pageSize: 5,
             noSearch: true,
             sortButton: false,
             hideCheckboxes: false,
             multiSelect: true,
             deselect: true,
             noAutoSelect: true,
             selectIdentifier: "protoId"
         };

     ctrl.selectInterfacesChanged = function(){
          ctrl.updateItemsToDelete({selectedInterfaces: ctrl.interfacesTableConfig.selectedItems});
          $scope.$root.closePopup('excludedInterfacesDlg_' + ctrl.modelId);
    }
}